import React, { useState } from "react";
import ModalForm from "./ModalForm";
import { Truck, ShieldCheck, Headset, Briefcase, Award, Handshake, TrendingUp, Calendar, Phone } from "lucide-react";

const About = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  return (
    <div className="max-w-7xl mx-auto px-6 py-12 text-black">
      <h1 className="text-6xl font-bold text-center mb-6 text-gradient">
        Выбирайте лучшее — <span className="text-red-600">МЕТАЛЛ ИВАНЫЧ</span>
      </h1>

      <p className="text-xl text-center mb-12 max-w-4xl mx-auto">
        Компания с более чем 10-летним опытом на рынке. Мы поставляем металл высокого качества с гарантией, оперативной доставкой и полным сервисом.
      </p>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
        {/* Блоки с карточками */}
        {[
          { icon: <Truck />, color: "bg-red-500", title: "Оперативная доставка", description: "Мы доставляем металл точно в срок, используя собственный автопарк." },
          { icon: <ShieldCheck />, color: "bg-green-500", title: "Гарантия качества", description: "Металл с необходимыми сертификатами, соответствующий всем стандартам." },
          { icon: <Headset />, color: "bg-blue-500", title: "Поддержка 24/7", description: "Наша команда всегда готова помочь с любыми вопросами." },
          { icon: <Briefcase />, color: "bg-yellow-500", title: "Долгосрочные партнерства", description: "Мы ценим стабильные и взаимовыгодные отношения с клиентами." },
          { icon: <Award />, color: "bg-orange-500", title: "Наши награды", description: "Отраслевые награды подтверждают высокий уровень наших услуг." },
          { icon: <Handshake />, color: "bg-purple-500", title: "Индивидуальный подход", description: "Предлагаем решения, максимально соответствующие вашим потребностям." },
          { icon: <TrendingUp />, color: "bg-teal-500", title: "Рост и развитие", description: "Мы внедряем инновационные решения, чтобы предложить лучшие условия." },
          { icon: <Calendar />, color: "bg-indigo-500", title: "Гибкий график", description: "Мы готовы работать по удобному для вас графику, чтобы удовлетворить все ваши потребности." },
          { icon: <Phone />, color: "bg-pink-500", title: "Удобная связь", description: "Мы обеспечиваем круглосуточную связь для быстрого решения всех вопросов." }
        ].map(({ icon, color, title, description }, index) => (
          <div key={index} className="relative bg-gray-50 py-8 px-6 rounded-lg shadow-xl hover:scale-105 transform transition-all duration-300">
            <div className={`absolute inset-0 ${color} opacity-25 rounded-lg -z-10`} />
            <div className="flex items-center mb-6">
              <div className={`text-white w-12 h-12 p-2 rounded-full bg-${color.replace('bg-', '')}`}>
                {icon}
              </div>
              <h2 className="text-2xl font-semibold text-black ml-4">{title}</h2>
            </div>
            <p className="text-lg text-gray-700">{description}</p>
          </div>
        ))}
      </div>

      <div className="mt-16 text-center">
        <h2 className="text-4xl font-bold text-black mb-6">Нужна консультация?</h2>
        <p className="text-xl text-gray-700 mb-6">
          Наши эксперты готовы помочь! Нажмите кнопку ниже для консультации.
        </p>
        <button
          onClick={handleOpenModal}
          className="bg-red-600 text-white text-xl px-10 py-4 rounded-full shadow-2xl hover:bg-red-700 transition"
        >
          Заказать консультацию
        </button>
      </div>

      {isModalOpen && <ModalForm onClose={handleCloseModal} />}
    </div>
  );
};

export default About;
